import { CheckResponse } from './types';
import { getLastObject } from './helpers/getLastObject';
import { StudentVisaDoc } from '../../types';
import { StudentVisaDocMap } from 'api-paths-cas';

export const PrevStudentVisaCalculation = (studentVisa?: StudentVisaDocMap, shortenedDate?: string): CheckResponse => {
  const lastStudentVisa = getLastObject<StudentVisaDoc>(studentVisa);

  if (lastStudentVisa && lastStudentVisa.startDate && lastStudentVisa.endDate) {
    return {
      startDate: lastStudentVisa.startDate,
      endDate: shortenedDate ? shortenedDate : lastStudentVisa.endDate,
    };
  }

  return;
};
